import dayjs from 'dayjs';
import React from 'react';
import 'react-table-6/react-table.css';
import 'styles/4-components/_react-table.scss';
import './ScanPerformanceByTimeListComponent.scss';
import { PerformanceScanByTime } from '../../../fetch/fetchScanPerformanceByTime';
import { PerformanceScanByTimePerStore } from '../../../fetch/fetchScanPerformanceByTimePerStore';
import { formatPosition } from '../ScanPerformanceList/ScanPerformanceListComponent/ScanPerformanceListComponent';
import {
  VizualizationScanPerformanceByTimeList,
  VizualizationScanPerformanceByTimePerStoreList,
} from './VizualizationScanPerformanceByTimeList';

declare interface PerformanceScanPosition extends PerformanceScanByTime {
  position: string;

  preSortScans: number;
}

declare interface PerformanceScanPerStorePosition
  extends PerformanceScanByTimePerStore {
  position: string;

  preSortScans: number;
}

export function ScanPerformanceByTimeListComponent({
  performanceScanList,
}: {
  performanceScanList: PerformanceScanByTime[];
}): JSX.Element {
  const newList: PerformanceScanPosition[] = performanceScanList
    .map((obj, index) => {
      const positionInCompetition = index + 1;
      return {
        ...obj,
        position: formatPosition(positionInCompetition),
        preSortScans: obj.nrOfFirstScans - obj.nrOfCompletedScans,
      };
    })
    .sort((a, b) => sortByTime(a.timePart, b.timePart));

  const data = React.useMemo(() => newList, [newList]);

  return (
    <div className="scan-table-wrapper">
      <VizualizationScanPerformanceByTimeList dataToShow={data} />
    </div>
  );
}

export function ScanPerformanceByTimeListPerStoreComponent({
  performanceScanList,
}: {
  performanceScanList: PerformanceScanByTimePerStore[];
}): JSX.Element {
  const newList: PerformanceScanPerStorePosition[] = performanceScanList
    .map((obj, index) => {
      const positionInCompetition = index + 1;
      return {
        ...obj,
        position: formatPosition(positionInCompetition),
        preSortScans: obj.nrOfFirstScans - obj.nrOfCompletedScans,
      };
    })
    .sort((a, b) => sortByTime(a.timePart, b.timePart));

  const data = React.useMemo(() => newList, [newList]);

  return (
    <div className="scan-table-wrapper">
      <VizualizationScanPerformanceByTimePerStoreList dataToShow={data} />
    </div>
  );
}

function sortByTime(aTime: string, bTime: string): number {
  if (dayjs(aTime).isAfter(dayjs(bTime))) {
    return 1;
  } else if (dayjs(aTime).diff(bTime) === 0) {
    return 0;
  } else {
    return -1;
  }
}

interface GraphTestData {
  date: string;
  [key: string]: any;
}

interface PartnersNameWithGraphColorTest {
  [key: string]: string;
}
